import { Injectable } from '@angular/core';
import { State } from '../models/state';

@Injectable({
  providedIn: 'root'
})
export class InstallationService {

  progress: any = 0;
  settled: any = false;
  success: any = false;
  error: any = null;
  href: any = null;
  manifest: any = null;
  launch: any = true;
  state: any;

  constructor(
    private stateObj: State,
  ) {
    this.progress = 0;
    this.state = this.stateObj.stateName;
    this.settled = false;
    this.success = false;
    this.error = null;
    this.href = null;
    this.manifest = null;
    this.launch = true;
  }

  public update(progress, state) {
    this.progress = Math.floor(progress)
    this.state = state
  }

  public okay(state) {
    
    
    this.settled = true
    this.progress = 100
    this.success = true
    this.state = state
  }

  public fail(err) {
    this.settled = true
    this.progress = 100
    this.success = false
    this.error = err
  }

}
